import React, { type ReactNode } from "react";

import { BLOCK } from "./constants";
import { type RichTextNode } from "./types";

const isHeaderRow = (row: RichTextNode): boolean =>
  row.type === BLOCK.TABLE_ROW &&
  !!row.content?.every((node) => node.type === BLOCK.TABLE_HEADER_CELL);

/**
 * Wrap the first rows with <thead /> if it consists of only <th> elements.
 * Wrap the rest of the rows with <tbody />.
 */
export const tableRenderer = (richTextNode: RichTextNode, children: ReactNode[]) => {
  if (richTextNode.type !== BLOCK.TABLE) {
    return children;
  }
  const { content: tableContent } = richTextNode;
  const [headerRows, bodyRows] = (tableContent || []).reduce<[RichTextNode[], RichTextNode[]]>(
    ([headers, body], row) => {
      return isHeaderRow(row) ? [[...headers, row], body] : [headers, [...body, row]];
    },
    [[], []]
  );
  const headerRowChildren = children.slice(0, headerRows.length);
  const bodyRowChildren = children.slice(headerRows.length, children.length);
  return (
    <div className="purpur-rich-text-table-scroll-container">
      <div className="purpur-rich-text-table-inner-scroll-container">
        <table>
          {headerRows.length > 0 && <thead>{headerRowChildren}</thead>}
          {bodyRows.length > 0 && <tbody>{bodyRowChildren}</tbody>}
        </table>
      </div>
    </div>
  );
};
